export function formatCurrency (value) {
  return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}



// WEBPACK FOOTER //
// ./src/utils/currency.js